import * as React from 'react';
import { PageRenderError } from "./PageRenderError";

// #region Component State

const initalState = {
    animationClasses    : "page-transition",
    errorWasCaught      : false as boolean
};

type State = Readonly<typeof initalState>;

// #endregion

// #region Component Props

interface IProps {
    // What the page is called, which every page says.  It was for the page views that were tracked, and nothing reads it now
    pageName?: string;
    children: any;
    classes?: string;
}

// #endregion

export class PageContent extends React.Component<IProps, State> {

    public state: State = initalState;

    public componentDidMount() {
        const ctx = this;
        setTimeout(() => {
            ctx.setState({
                animationClasses: ""
            });
        }, 300);
    }

    public componentDidCatch(error: any, info: any) {
        this.setState({
            errorWasCaught: true
        });

        console.error(error, info);
    }

    public render() {

        if (this.state.errorWasCaught) {
            return <div className="page-content"><PageRenderError /></div>;
        }

        return <div className={`page-content ${this.state.animationClasses} ${this.props.classes ? this.props.classes : ''}`}>{this.props.children}</div>;
    }
}
